/**
 * @fileoverview GET handler for the "/data_objects/user_relationship_type_schema" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserRelationshipTypeSchema } from "./constants";
import type { GetCustomObjectsUserRelationshipTypeSchemaResult } from "./types";
import { isGetCustomObjectsUserRelationshipTypeSchemaResult } from "./validators";

export const getCustomObjectsUserRelationshipTypeSchema = reactQueryFetcherAdapter(
  customObjectsUserRelationshipTypeSchema,
  (
    signal: AbortSignal,
    typeName: string,
    relKind: string
  ): Promise<GetCustomObjectsUserRelationshipTypeSchemaResult> => {
    return fetch(
      "/data_objects/user_relationship_type_schema",
      "GET",
      { type_name: typeName, rel_kind: relKind },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsUserRelationshipTypeSchemaResult
);
